var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{on:{"click":function($event){return _vm.triggerFileInput()}}},[_c('span',{staticClass:"btn-text"},[_vm._v("Import")]),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/png,image/jpeg,image/jpg"},on:{"change":_vm.handleFileSelect}})])
}
var staticRenderFns = []

export { render, staticRenderFns }